var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneClientHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.589202 25.4549C0.467669 25.2444 0.467669 24.9851 0.589202 24.7746L14.5 0.680367C14.6215 0.46986 14.8461 0.340187 15.0892 0.340187L42.9108 0.340187C43.1539 0.340187 43.3785 0.46986 43.5 0.680367L57.4108 24.7746C57.5323 24.9851 57.5323 25.2444 57.4108 25.4549L43.5 49.5491C43.3785 49.7596 43.1539 49.8893 42.9108 49.8893L15.0892 49.8893C14.8461 49.8893 14.6215 49.7596 14.5 49.5491L0.589202 25.4549Z",
    fill: "url(#paint0_linear_47_42)",
    stroke: "#B9DCDA",
    strokeWidth: 0.680352
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.583 30.321C20.553 29.227 20 28 20 26.011C20 22.511 22.457 19.374 26.03 17.823L26.923 19.201C23.588 21.005 22.936 23.346 22.676 24.822C23.213 24.544 23.916 24.447 24.605 24.511C26.409 24.678 27.831 26.159 27.831 28C27.831 28.9283 27.4623 29.8185 26.8059 30.4749C26.1495 31.1313 25.2593 31.5 24.331 31.5C23.258 31.5 22.232 31.01 21.583 30.321ZM31.583 30.321C30.553 29.227 30 28 30 26.011C30 22.511 32.457 19.374 36.03 17.823L36.923 19.201C33.588 21.005 32.936 23.346 32.676 24.822C33.213 24.544 33.916 24.447 34.605 24.511C36.409 24.678 37.831 26.159 37.831 28C37.831 28.9283 37.4623 29.8185 36.8059 30.4749C36.1495 31.1313 35.2593 31.5 34.331 31.5C33.258 31.5 32.232 31.01 31.583 30.321Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_42",
    x1: 0.0000356457,
    y1: 49.0125,
    x2: 1.70144,
    y2: -0.28352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461633,
    stopColor: "#73B8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D1B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(17 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClientHeader);
export default __webpack_public_path__ + "static/media/one_client_header.a29226c6e15978017f9161d2ba5a15c7.svg";
export { ForwardRef as ReactComponent };